import logo from "../assets/img/logo_tonderblanco.svg";
import { useRef, useState } from "react";

export default function ModalForm(props) {

    const emailInputRef = useRef();
    const nameInputRef = useRef();
    const websiteURL = useRef();
    const [plataform, setPlataform] = useState(undefined);

    const [error, setError] = useState(undefined);

    const onValueChange = (e) => {
        setPlataform(e.target.value)
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (emailInputRef.current.value === "" || nameInputRef.current.value === "" || websiteURL.current.value === "" || plataform === undefined) {

            setError('Please complete all fields');

        } else {

            setError('');

            props.onValidated({
                EMAIL: emailInputRef.current.value,
                MERGE1: nameInputRef.current.value,
                MERGE6: websiteURL.current.value,
                MERGE7: plataform
            });
        }
    }

    return (
        <div className="overflow-y-auto fixed left-0 right-0 xl:h-full z-50 m-auto w-full xl:w-4/12 h-4/6 ">
            <div className="sm:flex sm:justify-center lg:justify-center">
                <div className="bg-white items-center text-center w-full">
                    
                    <div className="pt-2 m-auto bg-tonder-blue w-full h-38">
                        <img className="w-36 h-36 m-auto"
                            src={logo} alt="logo"></img>
                            
                    </div>
                    <h1 className="mt-4 text-center text-3xl font-jakarta font-medium text-transparent bg-clip-text bg-gradient-to-r from-black to-tonder-blue">
                        Book a demo with Tonder
                    </h1>
                    <div className="mx-2 col-span-12 text-center pb-6 xl:flex xl:col-span-8 lg:flex  lg:col-span-8 md:flex  md:col-span-8">

                        <form className="mt-4 text-left pl-4 pb-16 w-full" onSubmit={(e) => handleSubmit(e)}>
                            <label htmlFor="email" className="font-jakarta font-bold">Email</label>
                            <br></br>
                            <input type="text" name='MERGE0' ref={emailInputRef}
                                className="rounded mt-2 border border-gray-300 w-11/12 py-1 mb-2">
                            </input>
                            <br></br>
                            <label htmlFor="name" className="font-jakarta font-bold">Name</label>
                            <br></br>
                            <input type="text" name='MERGE0' ref={nameInputRef}
                                className="rounded mt-2 border border-gray-300 w-11/12 py-1 mb-2">
                            </input>
                            <br></br>
                            <label htmlFor="website" className="font-jakarta font-bold">Website URL</label>
                            <br></br>
                            <input type="text" name='MERGE0' ref={websiteURL}
                                className="rounded mt-2 border border-gray-300 w-11/12 py-1 mb-2">
                            </input>
                            <br></br>
                            <label htmlFor="email" className="font-jakarta font-bold">Platform</label>
                            <br></br>
                            <div id="mergeTable" className="mergeTable">
                                <div className="mergeRow dojoDndItem mergeRow-radio" id="mergeRow-7">
                                    <div className="field-group">
                                        <ul className="mt-2" id="MERGE7">
                                            <li>
                                                <label className="radio" htmlFor="MERGE7-0">
                                                    <input type="radio" name="MERGE7" id="MERGE7-0" value="Woo Commerce" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>Woo Commerce</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label className="radio" htmlFor="MERGE7-1">
                                                    <input type="radio" name="MERGE7" id="MERGE7-1" value="Shopify" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>Shopify</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label className="radio" htmlFor="MERGE7-2">
                                                    <input type="radio" name="MERGE7" id="MERGE7-2" value="Magento 2" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>Magento 2</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label className="radio" htmlFor="MERGE7-3">
                                                    <input type="radio" name="MERGE7" id="MERGE7-3" value="PrestaShop" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>PrestaShop</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label className="radio" htmlFor="MERGE7-4">
                                                    <input type="radio" name="MERGE7" id="MERGE7-4" value="BigCommerce" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>BigCommerce</span>
                                                </label>
                                            </li>
                                            <li>
                                                <label className="radio" htmlFor="MERGE7-5">
                                                    <input type="radio" name="MERGE7" id="MERGE7-5" value="WIX" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>WIX</span>
                                                </label>
                                            </li><li>
                                                <label className="radio" htmlFor="MERGE7-6">
                                                    <input type="radio" name="MERGE7" id="MERGE7-6" value="Tienda Nube" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>Tienda Nube</span>
                                                </label> </li><li>
                                                <label className="radio" htmlFor="MERGE7-7">
                                                    <input type="radio" name="MERGE7" id="MERGE7-7" value="VTEX" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>VTEX</span>
                                                </label>
                                            </li><li>
                                                <label className="radio" htmlFor="MERGE7-8">
                                                    <input type="radio" name="MERGE7" id="MERGE7-8" value="Other" className="mr-2" onChange={(e) => onValueChange(e)} />
                                                    <span>Other</span>
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="text-jakarta text-white text-center m-auto w-full">
                                <input type="submit" className=" py-2 px-4 rounded-md  font-medium transition ease-in-out  hover:scale-105  text-white bg-tonder-blue " name="submit" value="Book Demo" />
                            </div>
                            {props.status === "sending" && (
                                <p className="mt-3 text-center"> {props.message}</p>
                            )}
                            {props.status === "error" && (

                                <p className="mt-3 text-center text-red-500">{props.message}</p>
                            )}
                            {props.status === "success" && (

                                <p className="mt-3 text-center font-jakarta font-medium text-black">Our experts will contact you shortly
                                </p>
                            )}
                            {error && <p className="mt-3 text-red-500 text-center">{error}</p>}

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

